import React, { useState, useEffect, useRef } from "react";
import Nav from "../../component/nav/nav";
import Maskitem from "./maskItem";
import ServiceItem from "./serviceItem";
// import Newsbox from "../../component/newsbox/index";
import Bot from "../../component/bot/index";
import CSS from "./index.module.scss";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { debounce } from "../../utils/index";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
// import "react-toastify/dist/ReactToastify.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import required modules
import { Navigation, Pagination } from "swiper/modules";
import { getNews, getNotice } from "../../api/index";
import { useInView } from "@react-spring/web";

const productList = [
  {
    name: "线上统一支付收银台",
    img: require("../../assets/products/paymb.png"),
    path: "/prodandsolution/prod/pay",
  },
  {
    name: "对账云平台",
    img: require("../../assets/products/cloud2x.png"),
    path: "/prodandsolution/prod/cloud",
  },
  {
    name: "POS-MIS",
    img: require("../../assets/products/posmis2x.png"),
    path: "/prodandsolution/prod/posmis",
  },
  {
    name: "分账系统",
    img: require("../../assets/products/fz2x.png"),
    path: "/prodandsolution/prod/fz",
  },
  {
    name: "UPAY",
    img: require("../../assets/products/upay2.png"),
    path: "/prodandsolution/prod/upay",
  },
  {
    name: "银医通",
    img: require("../../assets/products/yyt2x.png"),
    path: "/prodandsolution/prod/yyt",
  },
  {
    name: "银校通",
    img: require("../../assets/products/yxt2x.png"),
    path: "/prodandsolution/prod/yxt",
  },
  {
    name: "小微云店",
    img: require("../../assets/products/xwyd2x.png"),
    path: "/prodandsolution/prod/xwyd",
  },
];

const Homepage = () => {
  const { t } = useTranslation();
  const [swiperRef, setSwiperRef] = useState(null);
  const [swiperRef2, setSwiperRef2] = useState(null);
  // const [swiperOutsourceRef, setSwiperOutersourceRef] = useState(null);
  const [mobile, setMobile] = useState(window.innerWidth < 1025);
  const [slideNum, setSlideNum] = useState(1);
  const [swiperIndex, setSwiperIndex] = useState(1);
  const [tabIndex, setTabIndex] = useState(0);

  const [briefel, seenBrief] = useInView({ threshold: 0.1, once: true });
  const [prodel, seenProd] = useInView({ threshold: 0.1, once: true });
  const [serviceel, seenService] = useInView({ threshold: 0.1, once: true });
  const [outsourceel, seenOutsource] = useInView({
    threshold: 0.1,
    once: true,
  });
  const [partnerel, seenPartnersource] = useInView({
    threshold: 0.1,
    once: true,
  });
  const [newsList, setNewsList] = useState([]);
  const [noticeList, setNoticeList] = useState([]);
  const [noticeListEn, setNoticeListEn] = useState([]);

  const navigate = useNavigate();

  const getNewstList = async () => {
    const res = await getNews({
      pageNum: 1,
      pageSize: 5,
      classId: 1,
    });
    if (res.code === 200) {
      setNewsList(res.data.list);
    }
  };
  const getNoticeList = async () => {
    const res = await getNotice({
      pageNum: 1,
      pageSize: 10,
      classId: 4,
    });
    if (res.code === 200) {
      const zh = [],
        en = [];
      res.data.list.forEach((item, idx) => {
        if (idx % 2 === 0) {
          en.push(item);
        } else {
          zh.push(item);
        }
      });
      setNoticeList(zh);
      setNoticeListEn(en);
    }
  };
  const goToLearn = () => {
    tabIndex === 0 ? navigate("/news") : navigate("/notice");
  };

  const goToCpurl = (url) => {
    window.open("http://" + url);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setMobile(window.innerWidth < 1025);
      setSlideNum(
        window.innerWidth < 1025
          ? window.innerWidth < 900
            ? window.innerWidth < 500
              ? 1
              : 2
            : 3
          : 4
      );
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    getNewstList();
    getNoticeList();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNavClick = (index) => {
    swiperRef.slideTo(index);
  };
  const goPrev = () => {
    if (swiperRef.isBeginning) {
      // toast.info("已经是第一张啦!", {
      //   position: "top-center",
      //   autoClose: 2000,
      //   theme: "colored",
      // });
    } else {
      swiperRef.slidePrev();
    }
  };
  const goNext = () => {
    if (swiperRef.isEnd) {
      // toast.info("已经是最后一张了哦！", {
      //   position: "top-center",
      //   autoClose: 2000,
      //   theme: "colored",
      // });
    } else {
      swiperRef.slideNext();
    }
  };
  const goPrev2 = () => {
    swiperRef2.slidePrev();
  };
  const goNext2 = () => {
    swiperRef2.slideNext();
  };
  const changeIndex = (e) => {
    setSwiperIndex(e.activeIndex + 1);
  };

  return (
    <div style={{ height: "100%" }}>
      <Nav
        styles={{ position: "fixed", left: "0", top: "0", zIndex: "10" }}
      ></Nav>
      <div className={mobile ? CSS.bgMobile : CSS.bgPc}>
        <div className={CSS.fontzone}>
          <div className={CSS.one}>{t("$singlee_hp3")}</div>
          <div className={CSS.two}>
            {mobile ? (
              <>
                {t("$singlee_hp4")}
                <br />
                {t("$singlee_hp5")}
              </>
            ) : (
              <>{t("$singlee_hp4") + "，" + t("$singlee_hp5")}</>
            )}
          </div>
          {/* <div className={CSS.three}>{t("了解更多") + "  >"}</div> */}
        </div>
      </div>

      <div className={mobile ? CSS.briefMobile : CSS.brief} ref={briefel}>
        <div
          className={`${CSS.briefContent} ${
            seenBrief ? CSS.briefContentAnimation : ""
          }`}
        >
          <div className={CSS.title}>{t("新利软件（集团）股份有限公司")}</div>
          <div className={CSS.content}>
            {t("$singlee_bf1")}
            <br />
            <br />
            {t("$singlee_bf2")}
            <br />
            <br />
            {t("$singlee_bf10")}
          </div>
          <div className={CSS.btn} onClick={() => navigate("/about/brief")}>
            {t("了解更多") + "  >"}
          </div>
        </div>
        <div className={CSS.map}></div>
        <div className={CSS.edifice}></div>
      </div>

      <div ref={prodel} className={`${CSS.animateBox}`}>
        <div
          className={`${CSS.prod} ${mobile ? CSS.prodMobile : ""} ${
            seenProd ? CSS.fadeIN : ""
          }`}
        >
          <div className={mobile ? CSS.maintitleMobile : CSS.maintitle}>
            {t("产品中心")}
          </div>
          {mobile ? (
            <></>
          ) : (
            <div className={CSS.option}>
              {productList.map((item, index) => {
                return (
                  <div
                    className={`${CSS.item} `}
                    key={index}
                    onClick={() => handleNavClick(index)}
                  >
                    {t(item.name)}
                  </div>
                );
              })}
            </div>
          )}
          <div style={{ width: "100%", position: "relative" }}>
            <Swiper
              pagination={
                mobile ? { bulletActiveClass: CSS.currentClass } : false
              }
              initialSlide={1}
              modules={[Navigation, Pagination]}
              onSwiper={setSwiperRef}
              slidesPerView={mobile ? 1 : 3}
              centeredSlides={true}
              spaceBetween={40}
            >
              {productList.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    {mobile ? (
                      <div
                        style={{
                          paddingBottom: "40px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          className={CSS.swiperItemMobile}
                          onClick={() => navigate(item.path)}
                        >
                          <div className={CSS.swiperItemImg}>
                            <img src={item.img} alt="" />
                          </div>
                          <div className={CSS.swiperItemTitle}>
                            {t(item.name)}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={CSS.swiperItem}>
                        <div className={CSS.swiperItemImg}>
                          <img src={item.img} alt="" />
                        </div>
                        <div className={CSS.swiperItemTitle}>
                          {t(item.name)}
                        </div>
                        <Maskitem
                          text={t(item.name)}
                          path={item.path}
                        ></Maskitem>
                      </div>
                    )}
                  </SwiperSlide>
                );
              })}
              {/* {customPrevButton}
          {customNextButton} */}
            </Swiper>
            {!mobile && (
              <>
                <button
                  className={`${CSS.prevNav} ${
                    mobile ? CSS.prevNavMobile : ""
                  }`}
                  onClick={goPrev}
                >
                  <div>{"<"}</div>
                </button>
                <button
                  className={`${CSS.nextNav} ${
                    mobile ? CSS.nextNavMobile : ""
                  }`}
                  onClick={goNext}
                >
                  <div>{">"}</div>
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      <div className={CSS.serviceBg} ref={serviceel}>
        <div
          className={`${CSS.service}`}
          style={{ height: mobile ? "auto" : "816px" }}
        >
          <div
            className={`${CSS.serviceInner} ${seenService ? CSS.fadeIN : ""}`} //${seenService ? CSS.fadeIN : ""}
          >
            <div
              className={mobile ? CSS.maintitleMobile : CSS.maintitle}
              style={{ marginTop: mobile ? "41px" : "81px" }}
            >
              {t("解决方案")}
            </div>
            <div
              className={mobile ? CSS.subtitleMobile : CSS.subtitle}
              style={{
                color: "#999",
                marginBottom: mobile ? "20px" : "42px",
              }}
            >
              {t("$singlee_hp1")}
            </div>
            {mobile ? (
              <Swiper
                pagination={{ bulletActiveClass: CSS.currentClass }}
                slidesPerView={slideNum}
                spaceBetween={40}
                grabCursor={true}
                modules={[Pagination]}
                className={CSS.cardSwiper}
              >
                <SwiperSlide className={`${CSS.cardboxOut}`}>
                  <div className={`${CSS.cardbox} ${CSS.retail}`}>
                    <div className={CSS.mask}>
                      <div className={CSS.title}>{t("$singlee_cr1")}</div>
                      <div className={CSS.whiteLine}></div>
                      <div className={CSS.text}>{t("$singlee_cr2")}</div>
                      <div
                        className={CSS.learnmore}
                        onClick={() =>
                          navigate("/prodandsolution/solution/retail")
                        }
                      >
                        {">"}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className={`${CSS.cardboxOut}`}>
                  <div className={`${CSS.cardbox} ${CSS.medical}`}>
                    <div className={CSS.mask}>
                      <div className={CSS.title}>{t("$singlee_yl1")}</div>
                      <div className={CSS.whiteLine}></div>
                      <div className={CSS.text}>{t("$singlee_yl2")}</div>
                      <div
                        className={CSS.learnmore}
                        onClick={() =>
                          navigate("/prodandsolution/solution/medical")
                        }
                      >
                        {">"}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className={`${CSS.cardboxOut}`}>
                  <div className={`${CSS.cardbox} ${CSS.park}`}>
                    <div className={CSS.mask}>
                      <div className={CSS.title}>{t("$singlee_pk1")}</div>
                      <div className={CSS.whiteLine}></div>
                      <div className={CSS.text}>{t("$singlee_pk2")}</div>
                      <div
                        className={CSS.learnmore}
                        onClick={() =>
                          navigate("/prodandsolution/solution/park")
                        }
                      >
                        {">"}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className={`${CSS.cardboxOut}`}>
                  <div className={`${CSS.cardbox} ${CSS.school}`}>
                    <div className={CSS.mask}>
                      <div className={CSS.title}>{t("$singlee_sc1")}</div>
                      <div className={CSS.whiteLine}></div>
                      <div className={CSS.text}>{t("$singlee_sc2")}</div>
                      <div
                        className={CSS.learnmore}
                        onClick={() =>
                          navigate("/prodandsolution/solution/school")
                        }
                      >
                        {">"}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            ) : (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  padding: "0 50px",
                  overflowX: "scroll",
                  justifyContent: "center",
                }}
              >
                <ServiceItem
                  imgurl="retail"
                  title="$singlee_cr1"
                  text="$singlee_cr2"
                />
                <ServiceItem
                  imgurl="medical"
                  title="$singlee_yl1"
                  text="$singlee_yl2"
                />
                <ServiceItem
                  imgurl="park"
                  title="$singlee_pk1"
                  text="$singlee_pk2"
                />
                <ServiceItem
                  imgurl="school"
                  title="$singlee_sc1"
                  text="$singlee_sc2"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className={`${mobile ? CSS.outsourceMobile : CSS.outsource}`}
        ref={outsourceel}
      >
        {mobile ? (
          <div
            className={`${CSS.containBox} ${
              seenOutsource ? CSS.botAnimation : ""
            }`}
          >
            <div className={CSS.maintitleMobile}>{t("$singlee_hp2")}</div>
            <div
              className={CSS.subtitleMobile}
              style={{ marginBottom: "20px", color: "rgb(153,153,153)" }}
            >
              {t("信息技术服务外包") + "(ITO)&" + t("业务流程外包") + "(BPO)"}
            </div>
            <Swiper
              pagination={{ bulletActiveClass: CSS.currentClass }}
              slidesPerView={slideNum === 1 ? 1 : 2}
              spaceBetween={40}
              grabCursor={true}
              modules={[Pagination]}
              className={CSS.cardSwiper}
            >
              <SwiperSlide className={`${CSS.cardboxOut}`}>
                <div className={`${CSS.cardbox} ${CSS.ito}`}>
                  <div className={CSS.mask}>
                    <div className={CSS.title}>{t("信息技术服务外包")}</div>
                    <div className={CSS.whiteLine}></div>
                    <div className={CSS.text}>{t("$singlee_it1")}</div>
                    <div
                      className={CSS.learnmore}
                      onClick={() => navigate("/service/ito")}
                    >
                      {">"}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className={`${CSS.cardboxOut}`}>
                <div className={`${CSS.cardbox} ${CSS.bpo}`}>
                  <div className={CSS.mask}>
                    <div className={CSS.title}>{t("业务流程外包")}</div>
                    <div className={CSS.whiteLine}></div>
                    <div className={CSS.text}>{t("$singlee_bp1")}</div>
                    <div
                      className={CSS.learnmore}
                      onClick={() => navigate("/service/bpo")}
                    >
                      {">"}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        ) : (
          <>
            <div
              className={`${CSS.left} ${
                seenOutsource ? CSS.leftAnimation : ""
              }`}
            >
              <div className={CSS.title}>{t("$singlee_hp2")}</div>
              <div>
                {t("信息技术服务外包") + "(ITO)&" + t("业务流程外包") + "(BPO)"}
              </div>
            </div>
            <div
              className={`${CSS.right} ${
                seenOutsource ? CSS.rightAnimation : ""
              }`}
            >
              <Swiper
                onSwiper={setSwiperRef2}
                slidesPerView={1}
                onActiveIndexChange={changeIndex}
              >
                <SwiperSlide className={CSS.slide}>
                  <div className={CSS.title}>{t("信息技术服务外包")}</div>
                  <div className={CSS.content}>{t("$singlee_it1")}</div>
                  <div
                    className={CSS.more}
                    onClick={() => navigate("/service/ito")}
                  >
                    {t("了解更多") + " >"}
                  </div>
                </SwiperSlide>
                <SwiperSlide className={CSS.slide}>
                  <div className={CSS.title}>{t("业务流程外包")}</div>
                  <div className={CSS.content}>{t("$singlee_bp1")}</div>
                  <div
                    className={CSS.more}
                    onClick={() => navigate("/service/bpo")}
                  >
                    {t("了解更多") + " >"}
                  </div>
                </SwiperSlide>
              </Swiper>
              <div className={CSS.lspan} onClick={goPrev2}>
                {"<"}
              </div>
              <div className={CSS.index}>{`0${swiperIndex}/02`}</div>
              <div className={CSS.rspan} onClick={goNext2}>
                {">"}
              </div>
            </div>
          </>
        )}
      </div>

      <div
        className={CSS.partner}
        style={{ padding: mobile ? "41px 40px" : "84px 128px 130px" }}
        ref={partnerel}
      >
        <div className={mobile ? CSS.maintitleMobile : CSS.maintitle}>
          {t("$singlee_ab_md5")}
        </div>
        <div
          className={mobile ? CSS.subtitleMobile : CSS.subtitle}
          style={{ color: "#333", marginBottom: mobile ? "20px" : "42px" }}
        >
          {t("$singlee_pt1")}
        </div>
        {mobile ? (
          <Swiper
            modules={[Pagination]}
            pagination={{ bulletActiveClass: CSS.currentClass }}
            slidesPerView={1}
            className={CSS.swiper}
          >
            <SwiperSlide
              style={{
                paddingBottom: "40px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className={CSS.contain}>
                <div className={`${CSS.imgV} ${CSS.index1}`}></div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              style={{
                paddingBottom: "40px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className={CSS.contain}>
                <div className={`${CSS.imgV} ${CSS.index2}`}></div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              style={{
                paddingBottom: "40px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className={CSS.contain}>
                <div className={`${CSS.imgV} ${CSS.index3}`}></div>
              </div>
            </SwiperSlide>
          </Swiper>
        ) : (
          <div
            className={`${CSS.imgH} ${seenPartnersource ? CSS.animation : ""}`}
          ></div>
        )}
      </div>

      <div className={`${CSS.news} ${mobile ? CSS.newsmobile : ""}`}>
        <div className={CSS.top}>
          <div style={{ flex: 1, display: "flex" }}>
            <div
              className={`${mobile ? CSS.tabmobile : CSS.tab} ${
                tabIndex === 0 ? CSS.select : ""
              }`}
              onClick={() => {
                setTabIndex(0);
              }}
            >
              {t("新闻中心")}
            </div>
            <div
              className={`${mobile ? CSS.tabmobile : CSS.tab} ${
                tabIndex === 1 ? CSS.select : ""
              }`}
              onClick={() => {
                setTabIndex(1);
              }}
            >
              {t("公司公告")}
            </div>
          </div>
          <div
            className={CSS.more}
            onClick={goToLearn}
            style={{ cursor: "pointer" }}
          >
            {t("了解更多") + " >"}
          </div>
        </div>
        {tabIndex === 0 &&
          (mobile ? (
            <div className={`${CSS.mobilecontain} ${CSS.active}`}>
              <div className={CSS.mobilenews}>
                {newsList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={CSS.item}
                      onClick={() => {
                        navigate(`/newsdetail`, { state: { id: item.pid } });
                      }}
                    >
                      <div className={CSS.title}>{item.title}</div>
                      <div className={CSS.time}>
                        {item.updatetime.split(" ")[0]}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className={`${CSS.newscontain} ${CSS.active}`}>
              {newsList.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={CSS.item}
                    onClick={() => {
                      navigate(`/newsdetail`, { state: { id: item.pid } });
                    }}
                  >
                    <div className={CSS.title}>{item.title}</div>
                    <div className={CSS.time}>
                      {item.updatetime.split(" ")[0]}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        {tabIndex === 1 &&
          (mobile ? (
            <div className={`${CSS.mobilecontain} ${CSS.active}`}>
              <div className={CSS.mobilenews}>
                {i18n.language === "zh"
                  ? noticeList.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={CSS.item}
                          onClick={() => goToCpurl(item.cpUrl)}
                        >
                          <div className={CSS.title}>{item.title}</div>
                          <div className={CSS.time}>
                            {item.updatetime.split(" ")[0]}
                          </div>
                        </div>
                      );
                    })
                  : noticeListEn.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={CSS.item}
                          onClick={() => goToCpurl(item.cpUrl)}
                        >
                          <div className={CSS.title}>{item.title}</div>
                          <div className={CSS.time}>
                            {item.updatetime.split(" ")[0]}
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
          ) : (
            <div className={`${CSS.newscontain} ${CSS.active}`}>
              {i18n.language === "zh"
                ? noticeList.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={CSS.item}
                        onClick={() => goToCpurl(item.cpUrl)}
                      >
                        <div className={CSS.title}>{item.title}</div>
                        <div className={CSS.time}>
                          {item.updatetime.split(" ")[0]}
                        </div>
                      </div>
                    );
                  })
                : noticeListEn.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={CSS.item}
                        onClick={() => goToCpurl(item.cpUrl)}
                      >
                        <div className={CSS.title}>{item.title}</div>
                        <div className={CSS.time}>
                          {item.updatetime.split(" ")[0]}
                        </div>
                      </div>
                    );
                  })}
            </div>
          ))}
      </div>

      <Bot></Bot>
    </div>
  );
};

export default React.memo(Homepage);
